/**
 * The onboarding step that shows the congratulation page. There are two types of this step:
 * 	- when all the steps got fulfilled
 * 	- when at least one step got skipped
 */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import { connect } from 'react-redux';
import Steps from './index';
import { getLinkToEditor } from 'utils/url';
import CongratulationStep from './assets/CongratulationStep.svg';
import { getRoute, ROOT } from 'routes';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const styles = {
	root: {
		height: '100%',
		margin: 'auto',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		position: 'relative'
	},
	title: {
		fontWeight: 'bold',
		marginBottom: 8
	},
	titleParagraph: {
		marginBottom: 63
	},
	subtitle: {
		fontWeight: 'bold'
	},
	skippedSection: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		marginTop: 30
	},
	skippedSectionLink: {
		fontWeight: 'bold'
	},
	navigation: {
		marginTop: 'auto',
		display: 'flex',
		flexDirection: 'column'
	},
	divider: {
		margin: '35px 0'
	},
	graphic: {
		width: 294,
		height: 200,
		marginTop: 20,
		background: `no-repeat url(${CongratulationStep}) center`,
		backgroundSize: 'contain'
	}
};

const OID = 'congratulations';

@withStyles(styles)
class CongratulationsStep extends Component {

	constructor(props) {
		super();
		props.onboarding.complete();
	}

	render() {
		const { classes, company } = this.props;
		const profileRoute = getRoute(ROOT, company.id);

		const titleClassName = {
			root: classes.title,
			paragraph: classes.titleParagraph
		};

		if (this.areSkippedSteps) {
			return (
				<div className={classes.root}>
					<Typography
						variant='h3'
						align='center'
						classes={titleClassName}
					>
						{localize('onboarding-congratulations-skipped-title')}
					</Typography>
					<Typography
						variant='subtitle1'
						align='center'
						className={classes.subtitle}
					>
						{localize('onboarding-congratulations-skipped-subtitle')}
					</Typography>
					{this.renderSkippedStepsSections()}
					{this.renderCommonSection()}
				</div>
			);
		}

		return (
			<div className={classes.root}>
				<Typography
					variant='h3'
					align='center'
					classes={titleClassName}
					paragraph
				>
					{localize('onboarding-congratulations-title')}
				</Typography>
				<Typography
					variant='subtitle1'
					align='center'
					className={classes.subtitle}
				>
					{localize('onboarding-congratulations-subtitle')}
				</Typography>
				<Typography variant='body1' align='center'>
					{localize('onboarding-congratulations-complete-profile1')}
					<Link component={RouterLink} to={profileRoute}>
						{localize('onboarding-congratulations-complete-profile2')}
					</Link>?
				</Typography>
				{this.renderCommonSection()}
			</div>
		);
	}

	renderSkippedStepsSections() {
		let sections = [];
		const { skipped } = this.props.onboarding;

		for (const Step of Steps) {
			const { oId, ...rest } = Step;
			if (skipped.indexOf(oId) !== -1) {
				sections.push(
					this.renderSkippedSection(oId, rest)
				);
			}
		}

		return sections;
	}

	renderSkippedSection(oId, params) {
		const { classes, company } = this.props;
		const { oTitle, oMessage, oRoute } = params;
		return (
			<div className={classes.skippedSection} key={`skipped-${oId}-section`}>
				<Link
					variant='body1'
					component={RouterLink}
					to={getRoute(oRoute, company.id)}
					underline='always'
					gutterBottom
					className={classes.skippedSectionLink}
				>{oTitle}</Link>
				<Typography variant='body1' align='center'>{oMessage}</Typography>
			</div>
		);
	}

	renderCommonSection() {
		const { classes, company } = this.props;
		return (
			<Fragment>
				<Typography variant='body1' className={classes.divider}>{localize('onboarding-congratulations-or')}</Typography>
				<Button
					variant='contained'
					size='large'
					color='primary'
					component='a'
					data-tid="button-congratulations-step-start-creating"
					href={getLinkToEditor(company.displayName)}
				>
					{localize('onboarding-congratulations-start-creating')}
				</Button>
				<div className={classes.graphic} />
			</Fragment>
		);
	}

	get areSkippedSteps() {
		const { skipped } = this.props.onboarding;
		return skipped.length > 0;
	}

}

CongratulationsStep.oId = OID;

CongratulationsStep.propTypes = {
	classes: PropTypes.object,
	onboarding: PropTypes.object,
	company: PropTypes.object
};

const mapStateToProps = state => ({
	company: state.companies.rawDataById[state.companies.selectedId]
});

export default connect(
	mapStateToProps,
	undefined
)(CongratulationsStep);



// WEBPACK FOOTER //
// ./src/containers/OnBoarding/Steps/CongratulationsStep.js